export const MAX_SHIFT_DURATION = 16;

// constants to track psource of  shift cancellation action
export const FROM_DASHBOARD = 'Dashboard';
export const FROM_QA_PANEL = 'QA Panel';
export const FROM_SHIFT_DETAILS = 'Shift Details';

export const DEFAULT_SHIFT_TIMES = [
	{ end_time: '14:00:00', start_time: '06:00:00' },
	{ end_time: '14:30:00', start_time: '06:30:00' },
	{ end_time: '15:00:00', start_time: '07:00:00' },
	{ end_time: '19:00:00', start_time: '07:00:00' },
	{ end_time: '22:00:00', start_time: '14:00:00' },
	{ end_time: '23:00:00', start_time: '15:00:00' },
	{ end_time: '07:00:00', start_time: '19:00:00' },
	{ end_time: '07:00:00', start_time: '23:00:00' }
];

export const SHIFT_NUDGE_STATUS = {
	EMPTY: 'EMPTY',
	FILLED: 'FILLED',
	WAITING: 'WAITING'
};

export const SHIFT_SECTION_STATUS = {
	CLOSED: 'Closed',
	ONGOING: 'Ongoing',
	OPEN: 'Open'
};
